import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/grants/profile")({
  head: () => ({
    meta: [
      { title: "Autofill Profile - DeckScore" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: RedirectToDashboard,
});

function RedirectToDashboard() {
  return <Navigate to="/dashboard" search={{ tab: "autofill" }} replace />;
}
